import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { turnReportsGetMissingReports } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type TurnReportsGetMissingReportsResponse = Awaited<
  ReturnType<typeof turnReportsGetMissingReports>
>;

export const useTurnsWithoutReport = (
  options?: Omit<
    UseQueryOptions<
      TurnReportsGetMissingReportsResponse extends { data: infer T }
        ? T
        : TurnReportsGetMissingReportsResponse,
      unknown,
      TurnReportsGetMissingReportsResponse extends { data: infer T }
        ? T
        : TurnReportsGetMissingReportsResponse,
      ['turnsWithoutReport']
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['turnsWithoutReport'],
    queryFn: () =>
      extractData(
        turnReportsGetMissingReports({
          query: {
            expand: ['route', 'shift', 'turnAssignments'],
            page: 0,
            perPage: 9999,
          },
        })
      ),
    ...options,
  });
};
